"use client";
import {
  useCompositeGroupLabel
} from "../__chunks/SWSPTQMT.js";
import "../__chunks/YUOJWFSO.js";
import "../__chunks/7HVFURXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox-group-label.tsx
var TagName = "div";
var useComboboxGroupLabel = createHook(function useComboboxGroupLabel2(props) {
  props = useCompositeGroupLabel(props);
  return props;
});
var ComboboxGroupLabel = forwardRef(function ComboboxGroupLabel2(props) {
  const htmlProps = useComboboxGroupLabel(props);
  return createElement(TagName, htmlProps);
});
export {
  ComboboxGroupLabel,
  useComboboxGroupLabel
};
